export const ProductSizeSelectorModeEnum = {
    ESSENTIAL: 'ESSENTIAL',
    ESSENTIAL_MULTI: 'ESSENTIAL_MULTI',
    STANDARD: 'STANDARD',
    SELECT: 'SELECT',
};
